export default "/img/FJ.2d1efd1c4ad659a7a1ddabc0f38953cb.png";